/* This input can be used in many places so we can't define model */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React from 'react';
import {observer} from 'mobx-react-lite';
import prefixes from './phonePrefixes.json';
import {Control, Controller, FieldError, UseFormRegister} from 'react-hook-form';
import {TextInput} from './TextInput';
import {useTranslation} from 'react-i18next';
import {OptionType, Select} from './Select';

export const countryPrefixes = prefixes.map((x) => {
  return {
    value: x.callingCode,
    label: x.countryName + ', ' + x.callingCode,
    key: x.mobilePrefix + x.countryName,
  };
});

interface PhoneInputProps {
  label?: string;
  required?: boolean;
  register: UseFormRegister<any>;
  errors?: FieldError | FieldError[];
  errorsPrefix?: FieldError | FieldError[];
  control: Control<any, any>;
}

export const PhoneInput: React.FunctionComponent<PhoneInputProps> = observer(
  ({register, errorsPrefix, errors, control}) => {
    const {t} = useTranslation();

    return (
      <>
        <Controller
          name="phoneNumberPrefix"
          control={control}
          rules={{required: true}}
          render={({field: {onChange, value}}) => (
            <Select
              label={t('Phone prefix')}
              className="col-start-1"
              options={countryPrefixes}
              value={countryPrefixes?.find((item) => item.value === value) ?? null}
              required={true}
              error={errorsPrefix}
              onChange={(e) => onChange((e as OptionType).value)}
            />
          )}
        />
        <TextInput
          label={t('Phone number')}
          {...register('phoneNumber', {required: true})}
          name="phoneNumber"
          error={errors}
        />
      </>
    );
  }
);
